import React from 'react';

import { EnergyBadge as Wrapper, Label, Svg, Path, ExtendedInfo, Letter } from './wrapper';

interface IEnergyBadge {
  efficiencyClass: string;
  mirrored?: boolean;
  neutral?: boolean;
  extended?: boolean;
  large?: boolean;
}

const EnergyBadge = ({ efficiencyClass, extended, mirrored, neutral, large }: IEnergyBadge) => (
  <Wrapper efficiencyClass={efficiencyClass} {...{ mirrored, neutral, extended, large }}>
    {extended && (
      <ExtendedInfo>
        <Letter>A</Letter>
        <svg width="3" height="7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path stroke="#000" d="M1.5 1.15161v5.63636" />
          <path d="M1.5.212158 0 2.09095h3L1.5.212158Z" fill="#000" />
        </svg>
        <Letter>G</Letter>
      </ExtendedInfo>
    )}
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 32">
      <Path d="M0 32h32l16-16L32 0H0z" />
    </Svg>
    <Label>{efficiencyClass}</Label>
  </Wrapper>
);

export default EnergyBadge;
